import React, { useState, useEffect } from "react";
import { withRouter, useHistory, useParams, Link } from "react-router-dom";
import cogoToast from "cogo-toast";
import { Formik } from "formik";
import { SystemConfigService } from "../../../service/configService";
import { Button, Form, Spinner } from "react-bootstrap";

const ViewDomain = () => {
  const [editMode, setEditMode] = useState(false);
  const [domain, setDomain] = useState(null);

  const history = useHistory();
  let { id } = useParams();

  const toastoptions = {
    hideAfter: 5,
    position: "top-right",
    heading: "Attention",
  };

  useEffect(() => {
    SystemConfigService.getDomain(id)
      .then((response) => {
        console.log(response.data);
        setDomain(response.data.data);
      })
      .catch((error) => {
        console.log(error.response.data);
      });
  }, [id]);

  return (
    <div>
      <div className="page-header">
        {domain && (
          <h3 className="page-title config-header-title">
            {" "}
            Domain <span>/ {domain.name} </span>
          </h3>
        )}
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={"/system-configuration/all"}>Portal configuration</Link>
            </li>
            {!editMode && (
              <li className="breadcrumb-item active" aria-current="page">
                <Button
                  onClick={() => {
                    setEditMode(true);
                  }}
                >
                  {" "}
                  Edit{" "}
                </Button>
              </li>
            )}
          </ol>
        </nav>
      </div>

      {domain && (
        <Formik
          initialValues={{
            id: domain.id,
            name: domain.name,
            url: domain.url,
            domain_name: domain.domain_name,
            active: domain.active ? "1" : "0",
          }}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            SystemConfigService.updateDomain(values)
              .then((response) => {
                console.log(response);
                setSubmitting(false);
                cogoToast.success("Domain updated successfully", toastoptions);
                setEditMode(false);
                history.push("/system-configuration/view-domains");
              })
              .catch((error) => {
                console.log(error.response);
                cogoToast.error(error.response.data.message, toastoptions);
                setSubmitting(false);
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
          }) => (
            <div className="mt-3 mb-3">
              <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                  <div className="card" style={{ border: "none" }}>
                    <div className="card-body">
                      <form className="pageForms" onSubmit={handleSubmit}>
                        <div className="row border-bottom mb-5">
                          <div className="col-md-6">
                            <Form.Group>
                              <label htmlFor="name"> Name </label>
                              <Form.Control
                                type="text"
                                className="form-control"
                                id="name"
                                name="name"
                                placeholder="Name of the domain"
                                disabled={!editMode}
                                autoComplete="off"
                                autoCorrect="off"
                                autoCapitalize="off"
                                spellCheck="false"
                                onChange={handleChange}
                                defaultValue={values.name}
                              />
                            </Form.Group>

                            <Form.Group>
                              <label htmlFor="url"> URL </label>
                              <Form.Control
                                type="text"
                                className="form-control"
                                id="url"
                                name="url"
                                placeholder="Enter URL"
                                disabled={!editMode}
                                autoComplete="off"
                                autoCorrect="off"
                                autoCapitalize="off"
                                spellCheck="false"
                                onChange={handleChange}
                                defaultValue={values.url}
                              />
                            </Form.Group>

                            <Form.Group>
                              <label htmlFor="domain_name"> Domain Name </label>
                              <Form.Control
                                type="text"
                                className="form-control"
                                id="domain_name"
                                name="domain_name"
                                placeholder="Name of the domain"
                                disabled={"disabled"}
                                autoComplete="off"
                                autoCorrect="off"
                                autoCapitalize="off"
                                spellCheck="false"
                                defaultValue={values.domain_name}
                              />
                            </Form.Group>

                            <Form.Group>
                              <label htmlFor="active"> Status</label>
                              <Form.Control
                                type="text"
                                as="select"
                                className="form-control"
                                id="active"
                                name="active"
                                placeholder="Name of the domain"
                                disabled={!editMode}
                                autoComplete="off"
                                autoCorrect="off"
                                autoCapitalize="off"
                                spellCheck="false"
                                onChange={handleChange}
                                defaultValue={
                                  values.active ? values.active : "DEFAULT"
                                }
                              >
                                <option value="DEFAULT" disabled></option>
                                <option value="1"> Yes </option>
                                <option value="0"> No </option>
                              </Form.Control>
                            </Form.Group>
                          </div>
                        </div>
                        {editMode && (
                          <div>
                            <button
                              type="submit"
                              className="btn btn-primary btn-icon-text"
                            >
                              <i className="mdi mdi-file-check btn-icon-prepend"></i>{" "}
                              Update&nbsp;&nbsp;
                              {isSubmitting ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                ""
                              )}
                            </button>

                            <button
                              className="btn btn-light"
                              onClick={() => {
                                setEditMode(false);
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        )}
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Formik>
      )}
    </div>
  );
};

export default withRouter(ViewDomain);
